export const menadzerski_ugovor_kao_radni_odnos= {
    templateId: 224,
    category: 15,
    templateTitle: "Ugovor o radu direktora kao menadžera - mješoviti ugovor radnog i obveznog prava",
    templateDescription: `<p>Ugovor o radu direktora kao menadžera je mješoviti ugovor (primjenjuju se odredbe radnog prava i dijelom obredbe obveznog prava), kojim ugovorne strane uređuju radnopravne elemente odnosa, ali i dodatna prava i obveze vezana uz funkciju menadžera, kao s osobe koja upravlja, vodi i odlučuje o poslovanju (direktor, član uprave, izvršni direktor i sl.).</p>`,
    description: `
      <h5>OPIS I SVRHA DOKUMENTA</h5>
      <p>Zakon o radu određuje da je radnik (zaposlenik, uposlenik, djelatnik, namještenik, službenik i slično) fizička osoba koja u radnom odnosu obavlja određene poslove za poslodavca.</p>
      <p>Treba naglasiti da Zakon o radu također propisuje da i <strong>član uprave ili izvršni direktor ili druga fizička osoba koja je prema posebnom zakonu, pojedinačno i samostalno ili zajedno i skupno, u drugom svojstvu ovlaštena voditi poslove poslodavca, može kao radnik u radnom odnosu obavljati određene poslove za poslodavca.</strong></p>
      <p>Dakle,  s obzirom na uređivanje pravnog statusa </strong>osoba koje upravljaju, vode i odlučuju o poslovanju</strong> poslodavca (određene su od strane skupštine društva kao osobe ovlaštene za zastupanje), navedene osobe mogu biti:</p>
      <p>1. radnici poslodavca koji ugovorom o radu (radnopravnim odnosom) uređuju sva međusobna prava i obveze (predložak takvog ugovora možete pogledati <a class="local-link" href="/contract?template=225">ovdje</a>),</p>
      <p>2. radnici poslodavca,  pri čemu <strong>mogu u jednom ugovoru</strong> (mješovitom ugovoru koji sadrži elemente radnog prava, ali i elemente obveznog prava) urediti elemente radnog odnosa, ali i takva dodatna prava i obveze koja se odnose na dodatni status osobe koja upravlja, vodi i odlučuje o poslovanju (tzv. ugovor o radu menadžera), </p>
      <p>3. radnici poslodavca  koji dodatno, <strong>uz već postojeći <a class="local-link" href="/contract?template=225">"osnovni"</a> ugovor o radu zaključuju i poseban menadžerski ugovor</strong>, kojim slobodno uređuju dodatna međusobna prava i obveze,</p>
      <p>4. <strong>isključivo menadžeri <strong> (zaključenjem menadžerskog ugovora), a bez da uspostavljaju radni odnos s poslodavcem. </p>
      <p>Predložak menadžerskog ugovora za opcije 3. i 4. možete pogledati <a class="local-link" href="/contract?template=223">ovdje</a>.</p>
      <p><strong>Ukoliko se ugovorne strane dogovore da menadžer i kao radnik obavlja određene poslove za poslodavca (opcija 1. u gore navedenom),  na takav radni odnos se ipak dijelom ne primjenjuju određene odredbe Zakona o radu, i to odredbe koje reguliraju prestanak ugovora o radu, (ali i o odredbe koje reguliraju rad na određeno vrijeme, otkazne rokove i otpremninu), pri čemu se na spomenute odredbe primjenjuje odredbe Zakona o obveznim odnosima koje dopuštaju da se ugovorne strane slobodno sporazumiju o navedenom.</strong></p>
      <p><strong>Također, radno vrijeme menadžera u vezi s trajanjem radnog dana i dnevnih normativa rada također je izuzeto od odredbi Zakona o radu te se ugovorne strane mogu slobodno dogovoriti u vezi radnog vremena menadžera, a s obzirom da je menadžer osoba od povjerenja koja može samostalno organizirati svoj rad.</strong></p>
      <p>U takvom ugovoru o radu menadžera, kao mješovitom ugovoru (radnog i obveznog prava), treba izbjegavati ugovaranje odredbi o prestanku ugovora, ugovoru o radu na određeno, otpremnini, otkaznim rokovima i radnom vremenu, na način da se poziva u istima na Zakon o radu ili na način da se prenose odredbe iz Zakona o radu.</p>
      <p>Radi pojašnjenja, bitno je naglasiti da u stvarnosti veliki broj “menadžera” zapravo ne ulaze u kategoriju “pravih” menadžera <strong>(osoba ovlaštenih voditi poslove poslodavca kao članovi uprave, direktori, izvršni direktori i sl.), nego su npr. rukovoditelji odjela, voditelji i sl.. Navedene osobe se u pravnom smislu ne mogu smatrati osobama koja upravljaju, vode i odlučuju o poslovanju, što dovodi do isključive primjene Zakona o radu na takav odnos odnosno nemogućnosti primjene prethodno izloženog, kao i predloška ugovora u nastavku.</p>
      <p>Primjer ugovora između osobe koja je ovlaštena voditi osobe poslodavca (direktor, član uprave, izvršni direktor i sl..), koji se zaključuje kao mješoviti ugovor o radu menadžera (uz obveznopravne elemente sadrži i radnopravne elemente), daje se u nastavku.      </p>

      <h5>NAJČEŠĆE GREŠKE</h5>
     
      <p><strong>- sklapanje menadžerskog ugovora za osobe koje nisu osobe ovlaštene za zastupanje (rukovoditelji, voditelji i sl.).</strong></p>
      <p>Pojašnjenje: u tom slučaju, navedeni ugovor se ima tumačiti u cijelosti prema Zakonu o radu, što znači da se i na takav ugovor primjenjuje odredbe Zakona o radu o prestanku ugovora, otpremnini, radu na određenu i otpremnini, što nije slučaj kod menadžerskih ugovora sklopljenim s osobama ovlaštenim za zastupanje. 
      </p>
      <h5>PRAVNA OSNOVA</h5>
      <p>Zakon o radu, Zakon o obveznim odnosima.</p>

    `,
  
    sides: [
      {
        signature: "Za Poslodavca:",
        inputs: [{
          type: "input",
          required: true,
          placeholder: "Poslovni subjekt",
        },
        {
          type: "input",
          required: true,
          placeholder: "Ulica i kućni broj",
        },
        {
          type: "input",
          required: true,
          placeholder: "Mjesto",
        },
        {
          type: "input",
          required: true,
          placeholder: "OIB",
        },
        {
          type: "input",
          placeholder: "Zastupa",
          inSignature: true,
        },
        {
          type: "input",
          placeholder: "Funkcija",
          inSignature: true,
        }],
        suffix: " (u daljnjem tekstu: Poslodavac, Društvo),",
        delimiter: `i`
      },
      {
        signature: "Radnik:",
        inputs: [{
          type: "input",
          required: true,
          placeholder: "Ime i prezime",
          inSignature: true,
        },
        {
          type: "input",
          required: true,
          placeholder: "Ulica i kućni broj",
        },
        {
          type: "input",
          required: true,
          placeholder: "Mjesto",
        },
        {
          type: "input",
          required: true,
          placeholder: "OIB",
        },
        ],
        suffix: " (u daljnjem tekstu: Menadžer),"
      }
    ],
  
    headline: "zaključuju sljedeći",
    title: "UGOVOR O RADU MENADŽERA",
  
    articles: [
      
        {
          title: 'PREDMET UGOVORA',
          mandatory: false,
          exampleContent: true, 
          statements: [
              {
                  type: 'text',
                  mandatory: true,
                  editable: true,
                  content: 'Ugovorne strane uvodno utvrđuju da je Menadžer imenovan Odlukom o imenovanju na mjesto člana uprave Društva (u daljnjem tekstu: Odluka). \r\nOvim Ugovorom, ugovorne strane sporazumno utvrđuju prava, obveze i ovlasti Menadžera. \r\nAko ovim Ugovorom, Pravilnikom o radu ili zakonom, odnosno drugim propisom nije određeno drukčije, Menadžer ima ista prava i obveze iz radnog odnosa, kao i svi ostali radnici Društva.',
              },
          ],
      },
    {
      title: "TRAJANJE UGOVORA",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: true,
          choices: [
            "Na temelju ovog Ugovora o radu zasniva se radni odnos između Poslodavca i Menadžera na određeno vrijeme, u periodu naznačenom Odlukom iz ovog Ugovora odnosno u trajanju od 4 godine.",
            "Na temelju ovog Ugovora o radu zasniva se radni odnos između Poslodavca i Menadžera na neodređeno vrijeme."
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
          help: 'Na odnos poslodavca i menadžera koji ujedno je i ovlašten za zastupanje društva, se ne primjenjuju odredbe Zakona o radu koje reguliraju prestanak ugovora o radu, (ali i o radu na određeno vrijeme, otkaznom roku i otpremnini), nego odredbe Zakona o obveznim odnosima, stoga se ugovor može sklopiti na određeno vrijeme bez navođenja objektivnog razloga.'
        }]
    },
    {
      title: 'POČETAK RADA',
      mandatory: true,
      statements: [
          {
              type: 'input',
              mandatory: true,
              editable: false,
              parts: [
                  {
                      type: 'text',
                      content: 'Menadžer započinje s radom kod Poslodavca dana'
                  },
                  {type: 'input', value: '', required: true,},
                  {type: 'text', content: ' godine​.'},
                  ],
          }],
  },
  {
    title: 'OBVEZE I OVLASTI MENADŽERA',
    mandatory: false,
    statements: [
        {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Menadžer je imenovan na funkciju člana uprave Društva na način predviđen aktima Društva. \r\nU ostvarivanju prava i obveza koje proizlaze iz spomenute funkcije, Menadžer će naročito:\r\n- obavljati sve poslove naznačene Odlukom iz ovog Ugovora, \r\n- provoditi odluke Skupštine Društva, \r\n- postupati u skladu s  općim aktima Društva, kao i  uputama dobivenim od Skupštine Društva, \r\n- u svakom pogledu i na svaki način postupati s pozornošću urednog i savjesnog gospodarstvenika te čuvati i unapređivati ugled i dobar glas Društva. \r\nMenadžer se obvezuje da će redovito izvještavati Skupštinu Društva o tijeku poslovanja i financijskom stanju Društva te će u sklopu istog podnositi redovita tromjesečna izvješća o postignutim poslovnim rezultatima Društva i stanju na tržištu.',
            value: '',
        }],
},
{
  title: 'RADNO MJESTO',
  mandatory: true,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Menadžer će obavljati sve poslove i zadatke na radnom mjestu član uprave Društva, a koji uključuju poslove navedene u ovom Ugovoru pod naslovom Obveze i ovlasti Menadžera.\r\nOsim toga, u obavljanju svojih poslova iz ovog Ugovora, Menadžer će ispunjavati sve dužnosti utvrđene Zakonom o trgovačkim društvima i drugim propisima, osnivačkim aktom društva, Poslovnikom o radu uprave Društva i ovim Ugovorom. \r\nMenadžer za svoj rad odgovara Skupštini Poslodavca. \r\nMenadžer će obavljati poslove i zadatke u poslovnim prostorijama, odnosno u drugim objektima Društva na teritoriju Republike Hrvatske. \r\nPoslodavac i Menadžer suglasno utvrđuju kako je Menadžer prije sklapanja ovog Ugovora upoznat sa sadržajem Pravilnika o radu Poslodavca te svim drugim općim aktima Poslodavca i  propisima u vezi s radnim odnosima, odlukama koje reguliraju poslovanje te da ga je Poslodavac upoznao s organizacijom rada, sistematizacijom i opisom radnih mjesta, platnim razredima i zaštitom zdravlja i sigurnosti na radu kao i da je od Poslodavca primio Priručnik zaštite na radu u svrhu upoznavanja s opasnostima u procesu rada.          ',
          value: '',
      }],
},
{
  title: 'RADNO VRIJEME, ODMORI I DOPUSTI',
  mandatory: true,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Imajući u vidu sadržaj i opseg navedenih dužnosti i ovlasti radnog mjesta, Menadžer se smatra osobom od povjerenja koja samostalno organizira svoj rad i koja je izuzeta iz standarda općega radnog zakonodavstva i organizacijskih propisa Društva u vezi s trajanjem radnog dana i dnevnih normativa rada, ali minimalno pridržavajući se sljedećih uvjeta: \r\n- Menadžer je obvezan na radnom mjestu raditi puno radno vrijeme od 40 sati tjedno, pet dana u tjednu, u koje je uključen dnevni odmor od 30 minuta dnevno, \r\n- Menadžer se osim rada u tijeku radnog vremena iz prethodne točke ovog stavka obvezuje biti dostupan ostalim članovima Skupštine Društva u svako doba, u smislu pružanja informacija važnih za poslovanje Društva, \r\n- Menadžer će tjedni odmor koristiti subotom i nedjeljom, \r\n- Menadžer ima pravo koristiti godišnji odmor u trajanju od 30 radnih dana u kalendarskoj godini.\r\nU slučaju da Menadžer ne iskoristi u cijelosti svoje pravo na godišnji odmor, preostali broj dana može iskoristiti u sljedećoj godini, a iznimno, ako Društvo o tome donese odluku, ima pravo i na naknadu štete za eventualne neiskorištene dane godišnjeg odmora. \r\nSukladno navedenom, Menadžer neće primati posebne naknade za prekovremeni rad, rad nedjeljom ili blagdanima te se za trajanja mandata obvezuje sve svoje radne sposobnosti i raspoloživo vrijeme staviti u službu najboljih interesa Društva, uključujući i obvezu da, po potrebi, obavlja i druge rukovodeće poslove i zadatke unutar Društva i povezanih društava.          ',
          value: '',
      }],
},
{
  title: 'PLAĆA MENADŽERA',
  mandatory: true,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Za ostvarenje obveza preuzetih ovim Ugovorom, Društvo će Menadžeru isplaćivati mjesečnu bruto plaću u iznosu od 20.000,00 kn. \r\nPlaća Menadžera isplaćivati će se u skladu s terminima isplate plaća ostalim zaposlenicima Društva, a prema izvoru koju definira pravo na isplatu plaće u određenom roku, no najkasnije do zadnjeg dana u mjesecu za prethodni mjesec. \r\nVisina i način isplate plaće Menadžera smatraju se poslovnom tajnom.',
          value: '',
      }],
},
  {
    title: 'STIMULACIJE',
    mandatory: false,
    statements: [
        {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Pored mjesečne plaće, Menadžer ima pravo na naknadu za postignute rezultate rada u vidu stimulacije.\r\nVisina, način i rokovi isplate stimulacije utvrđeni su sustavom  nagrađivanja i stimulacija koji se primjenjuje u Društvu. \r\nDruštvo zadržava pravo da Menadžeru isplati dio udjela u dobiti ili ukupni udio u dobiti ili na neki drugi način u skladu s važećim zakonskim propisima i općim aktima Društva.',
        },
    ],
},
{
  title: 'TROŠKOVI I BENEFICIJE',
  mandatory: false,
  examplecontent: true,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Menadžer će imati pravo na sljedeće beneficije i naknadu troškova: \r\n- naknadu troškova reprezentacije, \r\n- troškova službenih putovanja u zemlji i inozemstvu, \r\n- članarine u stručnim udruženjima, \r\n- domaće i strane literature, \r\n- posjete stručnim sajmovima i izložbama,  \r\nsve do maksimalnih iznosa utvrđenih posebnom odlukom Skupštine Društva za svaku poslovnu godinu. \r\nDruštvo može odobriti Menadžeru daljnja stručna i druga usavršavanja Menadžera u skladu s potrebama i mogućnostima Društva. \r\nZa vrijeme odobrenog stručnog usavršavanja Menadžer će imati pravo na plaću iz ovog Ugovora.',
          value: '',
      }],
},
{
  title: 'POSLOVNA TAJNA',
  mandatory: false,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Za potrebe ovog Ugovora poslovnom tajnom smatraju se svi podaci, dokumenti, planovi i postupci koji se na bilo koji način odnose ili su u vezi s poslovanjem Društva ili radom radnika Društva, a čije bi neovlašteno priopćavanje bilo protivno interesima Društva. Poslovnom tajnom smatraju se naročito: sheme i podaci o makro i mikro organizaciji, principi rukovođenja i poslovnog informiranja, sofver, način postupanja u komercijalnim poslovima i odnosima, poslovne informacije, liste komitenata i poslovnih partnera, te plaće, stimulacije i ostale beneficije svih  radnika Društva. \r\nMenadžer se obvezuje na svaki način i neograničeno čuvati  poslovnu tajnu Društva, kako tijekom trajanja ovog Ugovora, tako i nakon njegovog prestanka. Nakon prestanka radnog odnosa u Društvu, Menadžer će predati Društvu sve izvornike i preslike podataka, dokumenata, planova i postupaka koji su mu bili na raspolaganju tijekom vršenja njegove funkcije. ',
          value: '',
      }],
},
{
  title: 'ZABRANA KONKURENCIJE',
  mandatory: false,
  examplecontent:true,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Za vrijeme trajanja ovog Ugovora, Menadžer se obvezuje da neće, bez prethodne pisane suglasnosti Društva: \r\n- za svoj ili tuđi račun obavljati bilo kakve poslove u drugim društvima i organizacijama, koji na bilo koji način konkuriraju djelatnosti i poslovanju Društva, osim  u slučajevima kada ga na to obveže Skupština ili drugi nadležni organ Društva, \r\n- biti osnivač ili suvlasnik društva ili organizacije ili član uprave ili nadzornog odbora društva koje na bilo koji način konkurira djelatnosti i poslovanju Društva, osim u onim društvima, i organizacijama u kojima je Društvo dioničar, vlasnik ili suvlasnik, odnosno u onim društvima u kojima ima kontrolu, \r\n- obavljati poslove za svoj osobni ili tuđi interes u prostorijama Društva.\r\nMenadžer se posebno obvezuje da neće biti član trgovačkog društva, ako se ono bavi poslovima iz predmeta poslovanja Društva za vrijeme važenja ovog Ugovora, kao i u roku od 2 (dvije) godine nakon prestanka njegovog važenja.\r\nMenadžer se nadalje obvezuje da  informacije i poslovne kontakte koje je na neposredan ili posredan način stekao tijekom obnašanja svoje funkcije u  Društvu prema ovom Ugovoru, neće koristiti za svoj ili tuđi račun za vrijeme trajanja ovog Ugovora, kao i neograničeno  nakon prestanka važenja ovog Ugovora. \r\nKršenje odredbi iz ovog članka osnova je za jednostrani  raskid ovog Ugovora od strane Društva i to bez otkaznog roka, kao i za prestanak radnog odnosa. Menadžer će snositi i svaku materijalnu odgovornost za štetu koju Društvo pretrpi zbog kršenja ovih odredbi.         ',
          value: '',
      }],
},
{
    title: "UGOVORNA ZABRANA NATJECANJA",
    mandatory: false,
    statements: [
      {
        type: "choice",
        mandatory: true,
        editable: true,
        choices: [
          "Ugovorne strane sporazumno utvrđuju da se u razdoblju od 2 (dvije) godine nakon prestanka važenja ovog Ugovora, Menadžer ne smije zaposliti kod druge osobe koja je u tržišnoj  utakmici s Društvom te ne smije za svoj ili za račun treće osobe sklapati poslove kojima se takmiči s Društvom. \r\nU slučaju da Menadžer postupi protivno odredbama ovoga članka, obvezuje se Poslodavcu isplatiti ugovornu kaznu u iznosu od 6  (šest) osnovnih mjesečnih  plaća Menadžera.\r\nDruštvo može pisanim putem obavijestiti Menadžera da odustaje od ugovorne zabrane utakmice, te se time oslobađa obveze plaćanja naknade utvrđene prethodnim stavkom.",
          "Ugovorne strane sporazumno utvrđuju da se u razdoblju od 2 (dvije) godine, nakon prestanka važenja ovog Ugovora, Menadžer ne smije zaposliti kod druge osobe koja je u tržišnoj  utakmici  s Društvom te ne smije za svoj ili za račun treće osobe sklapati poslove kojima se takmiči s Društvom. \r\nU slučaju iz prethodnog stavka Društvo se obvezuje da će Menadžeru za vrijeme trajanja zabrane isplaćivati naknadu u iznosu od jedne polovice (1/2) prosječne plaće isplaćene Menadžeru u 3 (tri) mjeseca prije prestanka Ugovora o radu. \r\nDruštvo može pisanim putem obavijestiti Menadžera da odustaje od ugovorne zabrane utakmice te se time oslobađa obveze plaćanja naknade utvrđene prethodnim stavkom.  \r\nZa slučaj da Menadžer prekrši odredbu o ugovornoj zabrani utakmice utvrđenu u prethodnom članku ovog Ugovora, dužan je podmiriti  Društvu cjelokupnu štetu koju je Društvo time pretrpilo. \r\nPored obveze Menadžera u slučaju opisanom u prethodnom stavku ovog članka,, Menadžer je dužan u roku od 15 dana od dana saznanja Društva za povredu zabrane vratiti Društvu cjelokupni iznos utrošen od strane Društva na edukaciju Menadžera (studiji, seminari, tečajevi i sl.), a prema stvarnoj specifikaciji troškova, zajedno sa kamatama po stopi utvrđenoj pozitivnim propisima, tekućim od dana svakog pojedinog plaćanja od strane Društva, do potpunog povrata uloženih sredstava Društvu. \r\nOdredba prethodnog stavka ovog Ugovora, ostaje valjana i na snazi i u slučaju kad Društvo pisano obavijesti Menadžera o svome odustanku od ugovorne zabrane utakmice."
        ],
        placeholder: "Odaberite ovdje te potom izmijenite po želji...",
        help: 'Ugovorna zabrana natjecanja može biti ugovorena na način da obvezuje poslodavca samo ako isplaćuje naknadu tijekom trajanja ugovorne zabrane natjecanja ili kao ugovorna kazna. Spomenute opcije su ovdje dane na izbor.'

      }]
  },
{
  title: 'PRAVA INDUSTRIJSKOG VLASNIŠTVA I AUTORSKA PRAVA',
  mandatory: false,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Društvo zadržava materijalna prava na izumima, tehničkim unapređenjima i autorskim djelima koje je Menadžer stvorio na radnom mjestu ili sredstvima Društva, odnosno podacima koji su mu stavljeni na raspolaganje radi izvršavanja radnih zadataka na temelju ovog Ugovora.\r\nOva prava gase se po isteku roka od 5 (pet) godina od prve primjene izuma, unapređenja ili autorskog djela.\r\nDruštvo se obvezuje o svom trošku izvršiti potrebne radnje u svrhu registracije tvorevina iz prethodnog stavka ovog članka kod nadležnih organa.',
          value: '',
      }],
},
{
  title: 'OTKAZ UGOVORA',
  mandatory: false,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'S obzirom da je Menadžer član uprave odnosno osoba koja je prema Zakonu o trgovačkih društvima ovlaštena pojedinačno i samostalno ili zajedno i skupno ovlaštena voditi poslove Poslodavca, a ujedno i radnik u radnom odnosu kod Poslodavca na temelju ovog Ugovora, na ovaj ugovorni odnos se ne primjenjuju odredbe Zakona o radu koje se odnose na prestanak ugovora o radu. \r\nSvaka ugovorna strana može otkazati ovaj Ugovor iz bilo kojeg razloga i bez obrazloženja, pisanom obavijesti drugoj ugovornoj strani uz otkazni rok od 60 (šezdeset) dana. \r\nOtkaz ovog Ugovora od strane Društva osnova je i za istodobni prestanak radnog odnosa između Poslodavca i Menadžera. \r\nNa temelju sporazuma ugovornih strana Menadžer može biti raspoređen na koje drugo radno mjesto u Društvu uz uvjete predviđene aktima Društva za takvo radno mjesto. \r\nU tom slučaju stranke će posebnim ugovorom iznova urediti svoje međusobne odnose.',
          value: '',
      }],
},
{
  title: 'OTPREMNINA',
  mandatory: false,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'U slučaju otkaza ovog Ugovora od strane Društva, Društvo će Menadžeru isplatiti otpremninu u visini 3 (tri) osnovne mjesečne  plaće, u roku od 30 dana od dana prestanka obavljanja menadžerske funkcije u Društvu. \r\nMenadžer neće imati pravo na otpremninu u sljedećim slučajevima: \r\n- ako prijeđe na drugu funkciju i/ili radno mjesto u okviru Društva, njegovih podružnica, društava s kojima je Društvo povezano ili drugih organizacija nad kojima Društvo ima kontrolu, \r\n- ako do prestanka radnog odnosa, odnosno otkaza ovog Ugovora dođe zbog  povrede radne dužnosti, nanošenja znatne štete Društvu i/ili kršenja zakonskih propisa i/ili akata Društva od strane Menadžera te zbog drugih činidaba i/ili propusta Menadžera koje Društvu nanose štetu, a rezultat su njegove namjere ili grube nepažnje, \r\n- ako do otkaza ovog Ugovora i/ili prekida radnog odnosa dođe iz razloga kršenja odredbi o zabrani konkurencije, poslovne tajne i ugovorne zabrane utakmice, \r\n- ako do otkaza ovog Ugovora i/ili radnog odnosa s Društvom dođe iz bilo kojeg razloga prije isteka 10  (deset) mjeseci od dana stupanja ovog Ugovora na snagu, s time da u razdoblje od navedenih 10 (deset) mjeseci ne ulazi vrijeme koje je Menadžer proveo na bolovanju, plaćenom ili neplaćenom dopustu, \r\n- ako su obje ugovorne strane s time suglasne.',
          value: '',
      }],
}, 
      {
        title: "ZAVRŠNE ODREDBE",
        mandatory: false,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: `Ovaj Ugovor se primjenjuje od dana potpisivanja.\r\nNa sve odnose ugovornih strana u smislu međusobnih prava i obveza kojima mogu slobodno raspolagati, koje nisu određene ovim Ugovorom primjenjuju se opća načela obveznog prava. \r\nIzmjene i dopune ovog Ugovora moraju biti u pisanom obliku.\r\nEventualne sporove nastale u vezi s Ugovorom, Poslodavac i Radnik pokušati će riješiti sporazumno, u protivnom, nadležan je stvarno nadležni sud prema sjedištu Poslodavca.`,
          }]
      },
      {
        title: 'PRIMJERCI UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                value: '',
            }],
      },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
      {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
      }
    ],
  
  };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/224_menadzerski_ugovor_kao_radni_odnos.ts